import { handleResponse, MyAxios, priorityHandleError } from '@services/SettingAxios';

class ServiceYaPay {
  orders(data: any): Promise<any> {
    return MyAxios.post('/api/yapay/orders', data).then(handleResponse).catch(priorityHandleError);
  }
}

const serviceYaPayInstance = new ServiceYaPay();

export default serviceYaPayInstance;
